{
  "Activate Insurance Verification": "Activate Insurance Verification",
  "Active": "Active",
  "Active Coverage": "Active Coverage",
  "Add Payer Connections": "Add Payer Connections",
  "Add payer credentials to expand coverage and unlock more complete insurance eligibility results.": "Add payer credentials to expand coverage and unlock more complete insurance eligibility results.",
  "Alternate Payer IDs": "Alternate Payer IDs",
  "An error occurred while overriding insurance status, Please try again.": "An error occurred while overriding insurance status, Please try again.",
  "Automatic Verifications": "Automatic Verifications",
  "Birthdate": "Birthdate",
  "Cancel": "Cancel",
  "Child": "Child",
  "Close": "Close",
  "Connect Payer": "Connect Payer",
  "Connect Payers": "Connect Payers",
  "Custom Date": "Custom Date",
  "Date of Birth*": "Date of Birth*",
  "Delta Dental has temporary data restrictions regarding the subscriber of your inquiry that prevents disclosure of eligibility data.  Please contact Delta Dental's customer service.": "Delta Dental has temporary data restrictions regarding the subscriber of your inquiry that prevents disclosure of eligibility data.  Please contact Delta Dental's customer service.",
  "Dependent": "Dependent",
  "Differs": "Differs",
  "Effective Date": "Effective Date",
  "End Date": "End Date",
  "Enter First Name*": "Enter First Name*",
  "Enter Last Name*": "Enter Last Name*",
  "Estimated Hours Saved": "Estimated Hours Saved",
  "Failed to load verification report data.": "Failed to load verification report data.",
  "Failure Details": "Failure Details",
  "First Name": "First Name",
  "Group Name": "Group Name",
  "Group Number": "Group Number",
  "Hide Details": "Hide Details",
  "If the correct insurance plan isn’t listed in the dropdown, add it in your PMS/EHR. It will appear here once added.": "If the correct insurance plan isn’t listed in the dropdown, add it in your PMS/EHR. It will appear here once added.",
  "In Progress": "In Progress",
  "Inactive": "Inactive",
  "Insurance Details": "Insurance Details",
  "Insurance Details Submitted for Verification!": "Insurance Details Submitted for Verification!",
  "Insurance Plan": "Insurance Plan",
  "Insurance Report": "Insurance Report",
  "Insurance Verification Data": "Insurance Verification Data",
  "Insurance Verified!": "Insurance Verified!",
  "Insurance eligibility results may be incomplete or limited without payer credentials.": "Insurance eligibility results may be incomplete or limited without payer credentials.",
  "Insurance status has been successfully overridden.": "Insurance status has been successfully overridden.",
  "Last Name": "Last Name",
  "Learn More": "Learn More",
  "Member ID": "Member ID",
  "Member ID*": "Member ID*",
  "Missing Payer Connections": "Missing Payer Connections",
  "NPI Selector*": "NPI Selector*",
  "NPI must be 10 characters long": "NPI must be 10 characters long",
  "National Provider ID": "National Provider ID",
  "No Plan configured in the PMS": "No Plan configured in the PMS",
  "No Plan configured in the PMS.": "No Plan configured in the PMS.",
  "No group name found. Please create a plan by adding the group name and group number in your PMS": "No group name found. Please create a plan by adding the group name and group number in your PMS",
  "Okay": "Okay",
  "On The Spot Verifications": "On The Spot Verifications",
  "Once completed, tap Refetch to load the updated insurance details.": "Once completed, tap Refetch to load the updated insurance details.",
  "Only numbers accepted for Tax ID": "Only numbers accepted for Tax ID",
  "Other Subscriber": "Other Subscriber",
  "Override Insurance": "Override Insurance",
  "PMS Payer ID": "PMS Payer ID",
  "Patient Information": "Patient Information",
  "Patient Zip Code": "Patient Zip Code",
  "Payer Company ID": "Payer Company ID",
  "Payer Company Name": "Payer Company Name",
  "Payer ID": "Payer ID",
  "Payer Name": "Payer Name",
  "Payer Not Supported for selected plan!": "Payer Not Supported for selected plan!",
  "Payer Not supported": "Payer Not supported",
  "Payer name": "Payer name",
  "Payer not supported": "Payer not supported",
  "Please create a plan by adding the group name and group number in your PMS and then click the \"Refetch\" button below.": "Please create a plan by adding the group name and group number in your PMS and then click the \"Refetch\" button below.",
  "Please ensure that your location is registered with the insurance payer": "Please ensure that your location is registered with the insurance payer",
  "Practice Type*": "Practice Type*",
  "Primary subscriber is not found with this insurance provider": "Primary subscriber is not found with this insurance provider",
  "Primary subscriber was found, but the patient as a dependent was not": "Primary subscriber was found, but the patient as a dependent was not",
  "Primary subscriber's memberId is either invalid, missing or unknown": "Primary subscriber's memberId is either invalid, missing or unknown",
  "Primary subscriber's name is either invalid, missing or unknown": "Primary subscriber's name is either invalid, missing or unknown",
  "Provider Information": "Provider Information",
  "Refetch": "Refetch",
  "Relationship": "Relationship",
  "Relationship to Subscriber": "Relationship to Subscriber",
  "Relationship*": "Relationship*",
  "Requested": "Requested",
  "Required": "Required",
  "Save": "Save",
  "Search Payer": "Search Payer",
  "Search for Patient Insurance Information": "Search for Patient Insurance Information",
  "Select Insurance Payer*": "Select Insurance Payer*",
  "Select Insurance Plan": "Select Insurance Plan",
  "Select Member ID*": "Select Member ID*",
  "Select Practice Type": "Select Practice Type",
  "Select Relationship": "Select Relationship",
  "Self": "Self",
  "Self Pay": "Self Pay",
  "Skip": "Skip",
  "Something went wrong during writeback process. Please try again!": "Something went wrong during writeback process. Please try again!",
  "Something went wrong while verifying insurance. Please try again.": "Something went wrong while verifying insurance. Please try again.",
  "Something went wrong! Please try again later.": "Something went wrong! Please try again later.",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",
  "Spouse": "Spouse",
  "Subscriber": "Subscriber",
  "Subscriber First Name*": "Subscriber First Name*",
  "Subscriber Information": "Subscriber Information",
  "Subscriber Last Name*": "Subscriber Last Name*",
  "Subscriber Zip Code": "Subscriber Zip Code",
  "Sync Payer/Group Plan": "Sync Payer/Group Plan",
  "Tax ID": "Tax ID",
  "Tax ID must be 9 characters long": "Tax ID must be 9 characters long",
  "Tax ID*": "Tax ID*",
  "This payer only supports website-based eligibility. Connect your payer account to verify patient eligibility.": "This payer only supports website-based eligibility. Connect your payer account to verify patient eligibility.",
  "This replaces existing info for {{patientName}}, Check writeback status in the Weave Portal under Insurance": "This replaces existing info for {{patientName}}, Check writeback status in the Weave Portal under Insurance",
  "To continue, please add the Group Name and Group Number for this patient’s insurance in your PMS or EHR.": "To continue, please add the Group Name and Group Number for this patient’s insurance in your PMS or EHR.",
  "Total Verifications": "Total Verifications",
  "Try Again": "Try Again",
  "Unknown": "Unknown",
  "Unverified": "Unverified",
  "Update": "Update",
  "Update Patient Insurance": "Update Patient Insurance",
  "Update Patient Insurance in PMS ?": "Update Patient Insurance in PMS ?",
  "Verification Data": "Verification Data",
  "Verification Successful": "Verification Successful",
  "Verify": "Verify",
  "Verify Insurance": "Verify Insurance",
  "View": "View",
  "View Report": "View Report",
  "Weave did not get a response from the insurance provider right now, try again later": "Weave did not get a response from the insurance provider right now, try again later",
  "Weave is not able to reach this insurance provider right now, try again later": "Weave is not able to reach this insurance provider right now, try again later",
  "Writeback": "Writeback",
  "Writeback Status": "Writeback Status",
  "Writeback Successful! The updated data will be available in your PMS soon": "Writeback Successful! The updated data will be available in your PMS soon",
  "You may search by entering patients: Employer Name or Group ID in the field below": "You may search by entering patients: Employer Name or Group ID in the field below",
  "Your dental office is out of network with this insurance provider": "Your dental office is out of network with this insurance provider",
  "{{month}} Verifications": "{{month}} Verifications"
}
